export const getFaqSectionMasterFilter = state => state.faqSectionMaster.filter
